import { Box, CircularProgress } from '@material-ui/core'
import powertoolsLogo from 'img/whiteTcgPowertools.png'
import './loading-screen.css'

export const LoadingScreen = (): JSX.Element => {
  return (
    <Box className="loading-screen-root">
      <Box>
        <Box padding={1} width="fit-content" margin="0 auto">
          <Box maxWidth="600px" width="90vw">
            <img width="100%" src={powertoolsLogo} />
          </Box>
        </Box>
        <Box width="fit-content" margin="20px auto">
          <CircularProgress style={{ color: 'white' }} size={100} />
        </Box>
      </Box>
    </Box>
  )
}
